import axios from 'axios';
import { useToast } from '../composables/useToast';

const LOGIN_PATH = '/login';

/**
 * Общие для всего приложения реакции на ответы: истёкшая сессия (401) и устаревший CSRF-токен (419).
 * Остальные ошибки обрабатывает вызывающий код (notifyHttpError / extractFieldErrors).
 */
export const installHttpClient = (client = axios) => {
    client.defaults.withCredentials = true;
    client.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    client.interceptors.response.use(
        response => response,
        (error) => {
            const status = error?.response?.status;

            if (status === 401 && window.location.pathname !== LOGIN_PATH) {
                window.location.assign(LOGIN_PATH);
            } else if (status === 419) {
                useToast().error('Сессия устарела. Обновите страницу и повторите действие.');
            }

            return Promise.reject(error);
        },
    );
};
